import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ContentContainer } from 'components/ContentContainer';
import { DocumentTitle } from 'components/DocumentTitle';
import { Icon } from 'components/Icon';
import { PageHeaderCard } from 'components/PageHeaderCard';
import Stepper from 'components/Stepper';
import { Heading } from 'components/Typography';
import { ASSIGNMENT_MIXPANEL_EVENTS } from 'domains/assignments/mixpanel';
import { CustomStructuredActivityCtx } from 'domains/customStructuredActivities/context';
import { STRUCTURED_ACTIVITY_STEPPER_TITLES } from 'domains/structuredActivities/steps';
import { useTrack } from 'utils/hooks/useMixPanel';
import PracticeOverview from 'domains/customStructuredActivities/Components/PracticeOverview';
import SubmitActivity from 'domains/customStructuredActivities/Components/SubmitActivity';

export const CustomStructuredActivityUI: React.FC = () => {
  useTrack(ASSIGNMENT_MIXPANEL_EVENTS.viewed.structuredActivity);
  const { t } = useTranslation();

  const {
    currentStep,
    onNavigateToStep,
    stepsState,
    structuredActivityContent: content,
  } = useContext(CustomStructuredActivityCtx);

  const { timeRequired, title } = content;

  return (
    <>
      <DocumentTitle>{t('structuredActivity.pageTitle')}</DocumentTitle>

      <ContentContainer variant="full">
        <PageHeaderCard textureVariant="purple">
          <Heading level="h6" as="h2">
            {t('structuredActivity.pageTitle')}
          </Heading>
          <Heading level="h2" className="text-center">
            {title}
          </Heading>

          <Heading level="h5" className="font-medium flex gap-12 items-start text-left">
            <Icon name="Clock" />
            <span>{t('structuredActivity.subTitle', { timeRequired })}</span>
          </Heading>
        </PageHeaderCard>

        <div className="flex flex-col items-start justify-center w-full max-w-[800px] self-center mb-64">
          <Stepper currentStep={currentStep} onNavigate={onNavigateToStep} className="my-40 sm-d:my-24 w-full">
            {Object.values(STRUCTURED_ACTIVITY_STEPPER_TITLES).map((stepTitle, index) => (
              <Stepper.Step key={stepTitle} index={index} isCompleted={stepsState[index]}>
                {stepTitle}
              </Stepper.Step>
            ))}
          </Stepper>

          <div className="flex flex-col gap-40 items-start">
            <PracticeOverview />
            <SubmitActivity />
          </div>
        </div>
      </ContentContainer>
    </>
  );
};
